/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgRecent = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <path
      d="M12 22C6.5 22 2 17.5 2 12h2c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8C8.5 4 5.9 6.3 4.7 8H7v2H2V4h2v1.6C5.8 3.8 8.6 2 12 2c5.5 0 10 4.5 10 10s-4.5 10-10 10zm3.6-7.1L11 12.6V7h2v4.4l3.4 1.7z"
      fill="currentcolor"
    />
  </Icon>
);
export { SvgRecent as Recent };
